// const BASE_URL = process.env.REACT_APP_API_URL || "http://localhost:5001/api";
// const BASE_URL = "https://dev.communitymagasin.com/api";
// const BASE_URL = "https://api.communitymagasin.com/api";
const BASE_URL = process.env.REACT_APP_API_URL ||  "http://localhost:5001/api/";
// const BASE_PHOTO_URL = "https://dev.communitymagasin.com"
// const BASE_URL = 'http://localhost:5001/api'
export default BASE_URL;
// 01626944727
